import { useTranslation } from "react-i18next";

import { THEME_PREFERENCES, isThemePreference } from "./theme";
import { useTheme } from "./useTheme";

/**
 * Theme picker for the app shell.
 *
 * A select rather than an on/off switch: the preference has three states, and
 * "follow the system" is the default we do not want to make unreachable once a
 * user has touched the control. It mirrors the language select sitting next to
 * it, down to the 44px touch target (CLAUDE.md §12).
 */
export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { preference, setPreference } = useTheme();
  return (
    <select
      aria-label={t("nav.theme")}
      title={t("nav.theme")}
      className={className ?? "bt-app__picker"}
      value={preference}
      onChange={(e) => {
        if (isThemePreference(e.target.value)) setPreference(e.target.value);
      }}
    >
      {THEME_PREFERENCES.map((value) => (
        <option key={value} value={value}>
          {t(`nav.theme_${value}`)}
        </option>
      ))}
    </select>
  );
}
